import { render, staticRenderFns } from "./EvalResponsibilityModal.vue?vue&type=template&id=2ecc3482&scoped=true"
import script from "./EvalResponsibilityModal.vue?vue&type=script&lang=js"
export * from "./EvalResponsibilityModal.vue?vue&type=script&lang=js"
import style0 from "./EvalResponsibilityModal.vue?vue&type=style&index=0&id=2ecc3482&prod&lang=css"
import style1 from "./EvalResponsibilityModal.vue?vue&type=style&index=1&id=2ecc3482&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecc3482",
  null
  
)

export default component.exports